import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  NotificationDetails: [],
  isLoading: false,
  error: "",
  hasData: false
};
const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    notificationDataRequest: state => {
      state.isLoading = true;
    },
    getNotificationDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.NotificationDetails = action.payload;
    },
    getNotificationDataFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});
export const {
  notificationDataRequest,
  getNotificationDataSuccess,
  getNotificationDataFailure
} = notificationSlice.actions;
export default notificationSlice.reducer;